import React, { useEffect, useRef, useState } from 'react';
import {
    Box,
    Text,
    Flex,
    IconButton,
    Heading,
    Grid,
    GridItem,
    useColorModeValue,
    useColorMode,
} from '@chakra-ui/react';
import { useBreakpointValue } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChevronUpIcon, ChevronDownIcon } from '@chakra-ui/icons';
import Boxx from '../../components/common/boxhome/boxx';
import Footer from "../../components/footer/footer";
import Lottie from 'lottie-react';
import Ai1 from '../../lotti-file/revenuegrowth/paidadversting.json';
import Ai2 from '../../lotti-file/revenuegrowth/abanonedcart.json';
import Ai3 from '../../lotti-file/revenuegrowth/ecommerce.json';
import Ai4 from '../../lotti-file/revenuegrowth/emailmarketing.json';
import Ai5 from '../../lotti-file/revenuegrowth/salesfunnel.json';
import Ai6 from '../../lotti-file/revenuegrowth/conversationrate.json';

import Ai7 from '../../lotti-file/revenuegrowth/paidwhite.json';
import Ai8 from '../../lotti-file/revenuegrowth/abanonedwhite.json';
import Ai9 from '../../lotti-file/revenuegrowth/ecommercewhite.json';
import Ai10 from '../../lotti-file/revenuegrowth/emailwhite.json';
import Ai11 from '../../lotti-file/revenuegrowth/salesfunnelwhite.json';
import Ai12 from '../../lotti-file/revenuegrowth/conversationwhite.json';



const solutions = [
    { title: "Digital Branding Solutions", path: "/digitalbranding" },
    { title: "Awareness Growth Solutions", path: "/awarenesssoutions" },
    { title: "Revenue Growth Solutions", path: "/revenuegrowth" },
    { title: "Social Media Management", path: "/socialmedia" },
    { title: "SEO", path: "/seo" },
    { title: "Performance Marketing", path: "/performancemarketing" },
];


const services = [
    { title: <Text as="span">'Paid Advertising<Text as="span" color="#FE3A3A"> (PPC)</Text> </Text>, description: 'Drive leads and conversions through expertly managed pay-per-click campaigns across search and display networks.', animationDataLight: Ai7, animationDataDark: Ai1, },
    { title: <Text as="span">Abandoned Cart <Text as="span" color="#FE3A3A">Recovery</Text> </Text>, description: 'Recover lost sales by re-engaging customers with automated, personalized follow-up messages.', animationDataLight: Ai8, animationDataDark: Ai2, },
    { title: <Text as="span">E-Commerce <Text as="span" color="#FE3A3A">Strategies</Text> </Text>, description: 'Full-service e-commerce solutions designed to optimize your product pages, streamline checkout, and boost online sales.', animationDataLight: Ai9, animationDataDark: Ai3, },
    { title: <Text as="span">Email <Text as="span" color="#FE3A3A">Marketing</Text></Text>, description: 'Nurture leads and convert them into customers with personalized, targeted email campaigns', animationDataLight: Ai10, animationDataDark: Ai4, },
    { title: <Text as="span">Sales Funnel <Text as="span" color="#FE3A3A">Optimization</Text></Text>, description: 'Refine every step of your customer’s journey to reduce friction and maximize revenue opportunities.', animationDataLight: Ai11, animationDataDark: Ai5, },
    { title: <Text as="span">Conversion Rate  <Text as="span" color="#FE3A3A">Optimization</Text></Text>, description: 'Active monitoring and engagement to build a loyal community, respond to comments, and foster meaningful interactions.', animationDataLight: Ai12, animationDataDark: Ai6, },

]
const Digitalbranding: React.FC = () => {
    const navigate = useNavigate();
    const scrollRef = useRef<HTMLDivElement>(null);
    const pathData = useBreakpointValue({
        base: "M0 10 Q75 0 200 10",
        md: "M0 20 Q150 0 300 20"
    });
    const { colorMode } = useColorMode();
    const [loading, setLoading] = useState(false);
    const location = useLocation();

    const selectedIndex = solutions.findIndex((solution) => solution.path === location.pathname);
    const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

    const handleSolutionClick = (index: number, path: string) => {
        setLoading(true);

        setTimeout(() => {
            navigate(path);
        }, 500);
    };

    useEffect(() => {
        // Scroll to the selected item when the page loads
        if (selectedIndex !== null && itemRefs.current[selectedIndex]) {
            itemRefs.current[selectedIndex]?.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest',
                inline: 'center',
            });
        }
        document.documentElement.scrollTop = 0; 
        document.body.scrollTop = 0; 
    }, [selectedIndex, location.pathname]);


    const gridTemplateColumns = useBreakpointValue({
        base: '1fr',
        md: 'repeat(2, 1fr)'
    });


    const textColor = useColorModeValue('#1C1C1C', 'white');
    const selectedTextColor = 'white';
    const bg = useColorModeValue('white', '#1C1C1C')
    const color = useColorModeValue('#FFFFF', 'white')
    return (
        <Grid
            bg={bg}
            templateColumns="1fr"
            gap={4}
            p={4}
            width="full"
            marginTop="auto"
        >
            <Box textAlign="center" mt={{ base: "10px", md: "20px" }} position="relative">
                <Text
                    fontSize={{ base: "12px", md: "28px" }}
                    lineHeight="36px"
                    fontWeight="400"

                >
                    <span style={{ fontFamily: "'Gilroy-Regular', sans-serif" }}>
                        Service /{' '}
                    </span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>
                        Performance Marketing
                    </span>
                </Text>

                <Box mt="10px" display="inline-block" ml={{ base: '90px', md: '120px' }}>
                    <svg width="100%" height="auto" viewBox="0 0 300 40">
                        <path
                            d={pathData}
                            fill="none"
                            stroke={colorMode === 'light' ? 'black' : 'silver'}
                            strokeWidth="2"
                        />
                    </svg>
                </Box>
            </Box>

            <Box textAlign="center" mt={{ base: "10px", md: "20px" }} position="relative">
                <Text
                    fontSize={{ base: "32px", md: "64px" }}
                    lineHeight={{ base: "40px", md: "78px" }}
                    fontWeight="400"
                >
                    <span style={{ fontFamily: "'Gilroy-Regular', sans-serif" }}>

                        What {' '}
                    </span>
                    <span style={{ color: '#FE3A3A', fontFamily: "'Cags Hetonal', sans-serif" }}>
                        we offer
                    </span>
                </Text>
            </Box>

            <Box
                ref={scrollRef}
                overflowX="auto"
                whiteSpace="nowrap"
                flexGrow={1}
                p={1}
                width="full"
                sx={{
                    '::-webkit-scrollbar': { display: 'none' },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                }}
            >
                <Flex
                    width="100%"
                    gap={6}
                    flexDirection="row"
                    overflowX="auto"
                    padding="10px"
                    maxWidth="100%"
                    sx={{
                        '::-webkit-scrollbar': {
                            display: 'none',
                        },
                        msOverflowStyle: 'none',
                        scrollbarWidth: 'none',
                    }}
                >
                    {solutions.map((solution, index) => (
                        <Box
                            key={solution.title}
                            ref={(el) => itemRefs.current[index] = el} 
                            onClick={() => handleSolutionClick(index, solution.path)}
                            borderRadius="md"
                            padding="10px"
                            fontFamily="'Gilroy-Regular', sans-serif"
                            cursor="pointer"
                            transition="background-color 0.3s"
                            bg={selectedIndex === index ? 'red.500' : 'transparent'}
                            flexShrink={0}
                        >
                            <Text
                                fontSize={{ base: "20px", md: "28px" }}
                                color={selectedIndex === index ? selectedTextColor : textColor}
                            >
                                {solution.title}
                            </Text>
                        </Box>
                    ))}
                </Flex>
            </Box>
            <Box
                height={{ base: "50vh", md: "100vh" }}
                width="100%"
                maxWidth="auto"
                bg="#000000"
                backgroundImage="url('/assets/images/svg/revenurpage.jpg')"
                backgroundSize="cover"
                backgroundPosition="center"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="20px"
                mt={4}
                opacity={1}
            >

            </Box>

            <Box textAlign="left" mt="10px">
                <Text
                    fontSize={{ base: '28px', md: '52px' }}
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                >
                    Descriptions
                </Text>
                <Text
                    order={{ base: 1, md: 0 }} 
                    fontFamily="'Gilroy-Regular', sans-serif"
                    fontSize={{ base: '16px', md: '28px' }}
                    fontWeight="400"
                    lineHeight={{ base: '24px', md: '36px' }}
                    color={color}
                    maxWidth={{ base: 'auto', md: 'auto' }}
                    textAlign="justify" 
                    pl="10px"
                    pr="10px"
                    mt="20px"
                    letterSpacing={{ base: '0.5px' }}
                >
                    Our Performance Marketing solutions are designed to maximize ROI through data-driven campaigns that deliver measurable, impactful results. We create and optimize campaigns across multiple digital platforms, ensuring that every marketing dollar you spend contributes to your business goals.
                </Text>
            </Box>
            <Grid
                mt="30px"
                templateColumns={{ base: '1fr', md: 'repeat(2, 1fr)' }}
                gap={{ base: 4, md: 6 }}
                p={{ base: 2, md: 4 }}
                maxWidth="100%"
                height="auto"
                mx="auto"
                overflowX="hidden"
            >
                {services.map((service, index) => (
                    <GridItem
                        key={index}
                        position="relative"
                        display="flex"
                        justifyContent="center"
                        height="100%" 
                    >
                        <Box
                            borderRadius="md"
                            p={4}
                            borderColor="gray.600"
                            mb={4}
                            textAlign="center"
                            mx="auto"
                            width="100%"
                            display="flex"
                            flexDirection="column"
                            justifyContent="space-between"
                            height="100%" 
                        >
                            {/* Lottie Box */}
                            <Box
                                mb={{ base: 2, md: -5 }}
                                display="flex"
                                justifyContent="center"
                                alignItems="center"
                                ml={{ md: "-10px" }}
                                width={{ base: '100px', md: '255px' }}
                                height={{ base: '60px', md: '162px' }}
                                mx="auto"
                                order={{ base: 0, md: -1 }}
                            >
                                <Lottie
                                    animationData={colorMode === 'light' ? service.animationDataLight : service.animationDataDark}
                                    loop={true}
                                />
                            </Box>

                            {/* Title and Description */}
                            <Box display="flex" flexDirection="column" alignItems={{ base: 'center', md: 'flex-start' }} mt={4}>
                                <Text
                                    fontSize={{ base: '16px', md: '40px' }}
                                    fontWeight="400"
                                    color={colorMode === 'light' ? 'black' : 'white'}
                                    whiteSpace="nowrap"
                                    overflow="visible"
                                    fontFamily="'Gilroy-SemiBold', sans-serif"
                                    textOverflow="ellipsis"
                                    maxWidth="100%"
                                    textAlign="center"
                                    mt={{ base: '0', md: '0' }}
                                >
                                    {service.title}
                                </Text>
                                <Text
                                    color={colorMode === 'light' ? 'black' : 'white'}
                                    fontSize={{ base: '14px', md: '25px' }}
                                    mt={1}
                                    textAlign="justify"
                                    fontFamily="'Gilroy-SemiBold', sans-serif"
                                >
                                    {service.description}
                                </Text>
                            </Box>

                            {/* Gradient Border (Bottom line) */}
                            <Box
                                mt={4}
                                border="1px solid"
                                sx={{
                                    borderImageSource:
                                        colorMode === 'light'
                                            ? 'linear-gradient(270deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
                                            : 'linear-gradient(270deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)',
                                    borderImageSlice: 1,
                                }}
                            />
                        </Box>

                        {/* Gradient Divider Between Items on Larger Screens */}
                        {index % 2 === 0 && index < services.length - 1 && (
                            <Box
                                display={{ base: 'none', md: 'block' }}
                                position="absolute"
                                top={0}
                                bottom={0}
                                right={0}
                                width="1px"
                                background={
                                    colorMode === 'light'
                                        ? 'linear-gradient(473deg, #FFFFFF 0%, #C92E2E 50%, #FFFFFF 100%)'
                                        : 'linear-gradient(473deg, #1C1C1C 0%, #C92E2E 50%, #1C1C1C 100%)'
                                }
                                height="100%"
                                transform="translateX(50%)"
                            />
                        )}
                    </GridItem>
                ))}
            </Grid>

            {/* BrandingInfoList component added here */}
            <Box mt={{ base: "50px", md: "100px" }} textAlign="center">
                <Text fontFamily="'Gilroy-Regular', sans-serif" fontSize={{ base: "12px", md: "28px" }} color={color}>
                    Frequently Asked Questions
                </Text>

                {/* "Our Top Services" Heading for mobile */}
                <Box textAlign="center" mt={{ base: '30px', md: '50px' }}>
                    <Heading
                        fontFamily="'Gilroy-SemiBold', sans-serif"
                        fontSize={{ base: "32px", md: "64px" }} 
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "78px" }} 
                        letterSpacing="-0.25px"
                        color="white"
                    >
                        <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif"> Questions?</Text>
                    </Heading>

                    <Text
                        fontFamily="'Cags Hetonal', sans-serif"
                        fontSize={{ base: "32px", md: "64px" }} 
                        fontWeight="400"
                        lineHeight={{ base: "40px", md: "78px" }} 
                        letterSpacing="-0.25px"
                        mt="10px"
                    >
                        <Text as="span" color={color}>Your </Text>
                        <Text as="span" color="#FE3A3A" fontFamily="'Cags Hetonal', sans-serif">Answers </Text>
                        <Text as="span" color={color} fontFamily="'Gilroy-SemiBold', sans-serif">are here  </Text>
                    </Text>
                </Box>
            </Box>
            <BrandingInfoList />
            <Text color={color} mt={{ base: "40px", md: "100px" }} fontSize={{ base: '12px', md: '28px' }} textAlign='center' fontFamily="'Gilroy-Medium', sans-serif">
                Get In Touch
            </Text>            <Boxx />
            <Footer />
        </Grid>
    );
};

interface BrandingInfoProps {
    title: string;
    content: string;
}

const BrandingInfo: React.FC<BrandingInfoProps> = ({ title, content }) => {
    const [isOpen, setIsOpen] = useState(false);
    const bg = useColorModeValue('white', '#1C1C1C')
    const color = useColorModeValue('#FFFFF', 'white')
    return (
        <Box
            bg={bg}
            maxW="auto"
            borderRadius={{ base: '10px', md: '20px' }}
            color={color}
            border={isOpen ? '1px solid #FE3A3A' : 'none'}
            overflow="hidden"
            mt={{ base: '10px', md: '14px' }} 
        >
            <Box
                display="flex"
                justifyContent="space-between"
                onClick={() => setIsOpen(!isOpen)}
                cursor="pointer"
                alignItems="center"
                border={isOpen ? '2px solid #FE3A3A' : 'none'}
                borderRadius="md"
                p={{ base: '10px', md: '20px' }} 
                backgroundColor={isOpen ? '#FE3A3A' : 'transparent'}
            >
                <Text
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                    fontWeight="400"
                    fontSize={{ base: "16px", md: "32px" }} 
                    lineHeight={{ base: "24px", md: "40px" }}
                >
                    {title}
                </Text>
                <IconButton
                    aria-label={isOpen ? "Collapse" : "Expand"}
                    icon={isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />}
                    fontSize={{ base: "24px", md: "30px" }}
                    variant="outline"
                    color={color}
                    borderColor="white"
                    _hover={{ bg: 'transparent' }}
                    p={{ base: 1, md: 1 }}
                />
            </Box>
            <Box p={isOpen ? 4 : 0} maxH={isOpen ? 'auto' : '0'} transition="max-height 0.2s ease-out">
                <Text
                    fontFamily="'Gilroy-Regular', sans-serif"
                    fontSize={{ base: "16px", md: "28px" }} 
                    lineHeight={{ base: '24px', md: '36px' }} 
                >
                    {content}
                </Text>
            </Box>
        </Box>
    );
};

const BrandingInfoList: React.FC = () => {
    return (
        <Box>
            <BrandingInfo title="How can digital marketing increase my business’s revenue?" content="Digital marketing helps you reach the right audience at the right time, driving qualified leads and improving your sales funnel, resulting in higher conversions and revenue growth. Q2. Which strategies work best to boost revenue in India?" />
            <BrandingInfo title="Which strategies work best to boost revenue in India?" content="A mix of paid advertising, SEO, performance marketing, and conversion rate optimization (CRO) are proven strategies for driving revenue growth, especially in India’s diverse market." />
            <BrandingInfo title="How soon can I expect to see results from a revenue growth campaign?" content="Paid campaigns usually yield results within 3-4 weeks, while SEO and content marketing may take 3-6 months to see significant revenue growth." />
            <BrandingInfo title="As a startup, how can I grow my revenue without a big marketing budget?" content="For startups, focusing on cost-effective strategies like targeted PPC ads, CRO, and retargeting can drive conversions and boost revenue without a large investment." />
            <BrandingInfo title="Will paid ads give immediate results for my startup?" content="Yes, platforms like Google and Facebook Ads can generate immediate traffic and sales, offering a quick boost to your revenue while optimizing your budget for maximum ROI." />
        </Box>
    );
};

export default Digitalbranding;
